<template>
  <div class="t-card">
    <h5 class="t-card--title">{{ $t("announcement.plural") }}</h5>

    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("common.system") }}</span>
        </template>
        <template v-if="pagination && pagination.docs.length">
          <div v-for="item in pagination.docs" :key="item._id">
            <notify-card :announcement="item" v-b-modal="'announcement-' + item._id" style="font-size: 14px;" />
            <modal :id="'announcement-' + item._id" :title="$t('announcement.detail')">
              <announcement-detail :announcement="item" />
            </modal>
          </div>

          <div class="d-flex">
            <div class="d-flex mt-auto">
              <b-pagination v-model="systemRequest.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="4" size="sm"></b-pagination>
            </div>
          </div>
        </template>
        <div v-else>
          <empty width="100px">
            <h5 class="text-center">
              {{ $t("announcement.no") }}
            </h5>
          </empty>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("organization.plural") }}</span>
        </template>
        <template v-if="myOrganizationAnnouncements && myOrganizationAnnouncements.docs.length">
          <div v-for="item in myOrganizationAnnouncements.docs" :key="item._id">
            <notify-card :announcement="item" v-b-modal="'my-announcement-' + item._id" style="font-size: 14px;" />
            <modal :id="'my-announcement-' + item._id" :title="$t('announcement.detail')">
              <announcement-detail :announcement="item" />
            </modal>
          </div>

          <div class="d-flex mt-auto justify-content-center">
            <b-pagination
              v-model="organizationRequest.options.page"
              :total-rows="myOrganizationAnnouncements.totalDocs"
              :per-page="myOrganizationAnnouncements.limit"
              limit="10"
              class="mt-4"
            >
              <template #page="{ page, active }">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </div>
        </template>
        <div v-else>
          <empty width="100px">
            <h5 class="text-center">
              {{ $t("announcement.no") }}
            </h5>
          </empty>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AnnouncementDetail from "@modules/announcement/announcement-detail";
import NotifyCard from "./notify-card.vue";

import Modal from "@c/modal.vue";

const state = "announcement";
export default {
  components: { NotifyCard, Modal, AnnouncementDetail },
  data() {
    return {
      systemRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },

      organizationRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },
      selectedAnnouncement: undefined,
    };
  },
  watch: {
    systemRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },
    organizationRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    myOrganizationAnnouncements() {
      return this.$store.getters[`organizationAnnouncement/myOrganizationAnnouncements`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
  },
  mounted() {},
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.systemRequest);
      this.$store.dispatch(`organizationAnnouncement/fetchUserAccessableAnnouncements`, this.organizationRequest);
      this.selectedItems = [];
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
  },
};
</script>

<style></style>
